import React from "react";
import { CalendarIcon } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { es } from "date-fns/locale";

/**
 * DateInput — reemplaza <input type="date"> con shadcn Calendar + Popover.
 * Props:
 *  - value: string ISO "YYYY-MM-DD" (o vacío)
 *  - onChange: (iso: string) => void
 *  - placeholder, disabled, className, testid
 */
export default function DateInput({ value, onChange, placeholder = "dd-mm-yyyy", disabled, className = "", testid }) {
  const toDate = (iso) => {
    if (!iso) return undefined;
    const s = String(iso).slice(0, 10);
    const [y, m, d] = s.split("-").map(Number);
    if (!y || !m || !d) return undefined;
    return new Date(y, m - 1, d);
  };
  const toIso = (date) => {
    if (!date) return "";
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  };
  const display = (iso) => {
    if (!iso) return "";
    const s = String(iso).slice(0, 10);
    const [y, m, d] = s.split("-");
    return y && m && d ? `${d}-${m}-${y}` : s;
  };
  const [open, setOpen] = React.useState(false);
  const selected = toDate(value);

  return (
    <Popover open={open} onOpenChange={(v) => !disabled && setOpen(v)}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testid}
          disabled={disabled}
          className={`w-full inline-flex items-center justify-between gap-2 h-10 px-3 rounded-lg border border-slate-200 bg-white text-sm text-left disabled:bg-slate-50 disabled:text-slate-400 hover:border-slate-300 focus:border-indigo-400 outline-none ${className}`}
        >
          <span className={selected ? "text-slate-700" : "text-slate-400"}>
            {selected ? display(value) : placeholder}
          </span>
          <CalendarIcon size={14} className="text-slate-400" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 bg-white" align="start">
        <Calendar
          mode="single"
          locale={es}
          selected={selected}
          defaultMonth={selected}
          onSelect={(d) => { if (d) { onChange(toIso(d)); setOpen(false); } }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
